import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { matchPhrases } from "../../../utils/utilities";

import Button from "../../themed/button";
import Input from "../../themed/input/input";

const elementSchema = z.object({
    name: z.string().min(1, { message: 'Element cannot be empty' }),
});

type ElementSchema = z.infer<typeof elementSchema>;

type Props = {
    element?: string;
    onCancelEdit?: () => void;
    elements: string[];
    onSaveElement: (element: string) => void;
};

const PMIResultElementForm: React.FC<Props> = ({ element, elements, onCancelEdit, onSaveElement }) => {
    const { control, handleSubmit, formState, setError, reset } = useForm<ElementSchema>({
        mode: 'all',
        resolver: zodResolver(elementSchema),
    });

    const onSubmitElement = (data: ElementSchema) => {
        const element = elements.find((element) => matchPhrases(element, data.name));
        if (element) return setError('name', { message: `${data.name} already exists!` });

        onSaveElement(data.name);
        reset({ name: '' });
    };

    useEffect(() => {
        reset({ name: element ? element : '' });
    }, [element, reset]);

    return ( 
        <form onSubmit={handleSubmit(onSubmitElement)}>
            <Controller
                name="name"
                control={control}
                render={({ field }) => (
                    <Input
                        id={field.name}
                        name={field.name}
                        value={field.value}
                        error={formState.errors.name ? formState.errors.name.message : null}
                        label={element ? "Update Element" : "Element Name"}
                        placeholder="Enter Element Name e.g. Fe"
                        onChange={field.onChange}
                    />
                )}
            />

            <div className="d-flex justify-content-end align-items-center">
                <Button label={element ? "Update" : "Save"} disabled={!formState.isValid} type="submit" />

                {onCancelEdit && (
                    <div className="mx-4">
                        <Button
                            label="Cancel"
                            style={{ backgroundColor: 'red' }}
                            onClick={onCancelEdit}
                        />
                    </div>
                )}
            </div>
        </form>
    );
};
 
export default PMIResultElementForm;